import './style.css';

export const InputSkeleton = ({ style }) => (
    <div className='input skeleton-loader' style={style}/>
);